import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/utils/metaPixel";

/**
 * Component that tracks page views for SPA navigation using Meta Pixel
 */
const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on every route change
    trackPageView();
  }, [location.pathname]);

  return null;
};

export default PageViewTracker;
